import { Suspense } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import Preloader from "common/preloader";
import { ResetScroll } from "helper";
import Navbar from "common/navbar/Navbar";
import Footer from "common/footer/Footer";
import InternetNotAvailableSnackbar from "common/no-internet-alert";
import { AOSRefresh } from "common/ASOInit";

const PagesRootLayout = () => {
  const { pathname } = useLocation();
  const { courtId } = useParams();
  const hideHeaderAndFooterPages = [
    `/book-court/${courtId}`,
  ].includes(pathname);
  return (
    <>
      <AOSRefresh />
      <ResetScroll />
      <InternetNotAvailableSnackbar />
      <Suspense fallback={<Preloader />}>
        {!hideHeaderAndFooterPages && <Navbar />}
        <Outlet />
        {!hideHeaderAndFooterPages && <Footer />}
      </Suspense>
    </>
  )
}

export default PagesRootLayout;